import { FilterModelType } from "types/business/FilterModelType";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = FilterModelType[];

export const useDefaultObservableFilterModelTypeArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectFilterModelTypeArray extends BehaviorSubject<CurrentType> {}
